export enum ViewState {
  ToApprove = 0,
  ToFinalApproval = 1,
  InProcess = 2,
  InBook = 3,
  Cancelled = 4,
  Unhandled = 5,
}

export enum PaymentNumberType {
  BG = 0,
  PG = 1,
  IBAN = 2,
}

export enum AgingIncomingInvoiceOverPaidActions {
  OverpaidAwaitingRefund = 0,
  OverpaidInfoSupplied = 1,
}

export enum AgingIncomingInvoiceUnderPaidActions {
  UnderpaidWithholdPaymentIntentionally = 0,
  UnderpaidHasBeenPaidInfoSupplied = 1,
  UnderpaidCreatePayment = 2,
  UnderpaidOtherInfoSupplied = 3,
}

export enum CreditPaymentHandling {
  Refund = 0,
  UseAgainstFutureInvoices = 1,
  Other = 2,
}
